

/**
 * @name CancelAppointmentController
 * @description Controller to cancel appointments
 * @param {library} $uibModalInstance The $uibModalInstance library from ui bootstrap
 * @param {service} Appointment The Appointment service
 * @param {resolve} appointment The appointment resolved from the parent controller
 * @param {resolve} project The projects resolved from the parent controller
 * @param {service} Notification The Notification service
 * @param {service} Session The Session service
 * @param {constant} NOTIFICATIONS The NOTIFICATIONS constant
 */
function CancelAppointmentController(
  $uibModalInstance,
  Appointment,
  appointment,
  project,
  Notification,
  Session,
  NOTIFICATIONS
) {
  let vm = this;
  vm.cancelType = 'temporary';
  vm.appointment = appointment;
  vm.project = project;

  vm.submit = function() {
    let status;
    if (vm.cancelType === 'temporary') {
      status = 10;
    } else if (vm.cancelType === 'permanent') {
      status = 90;
    }

    // Send the Appointment Update
    Appointment.update(vm.appointment, status).then(function(appointment) {
      $uibModalInstance.close(appointment);

      // Send the reschedule later notification
      if (vm.cancelType === 'temporary') {
        let rescheduleNotification = {
          recipients:
          [/* API to send to everyone connected to this appointment */],
          notificationId: NOTIFICATIONS.appointmentReschedule,
          messageObjects: {
            appointmentId: vm.appointment.id,
            projectId: vm.appointment.project,
            artistId: vm.appointment.artist.id, // The artist assigned to the appointment
            collectorId: vm.project.collector.id, // The collector who owns the project
            operatorId: Session.collector.id // The operator/artist who's logged in and has cancelled the apointment
          },
          messageVariables: {
            subject: Session.collector.first_name + ' ' +
            Session.collector.last_name +
            ' cancelled this appointment and plans to reschedule a new one later'
          }
        };
        Notification.send(rescheduleNotification);

      // Send the cancellation notification
      } else if (vm.cancelType === 'permanent') {
        let cancelNotification = {
          recipients:
          [/* API to send to everyone connected to this appointment */],
          notificationId: NOTIFICATIONS.appointmentCancellation,
          messageObjects: {
            appointmentId: vm.appointment.id,
            projectId: vm.appointment.project,
            artistId: vm.appointment.artist.id, // The artist assigned to the appointment
            collectorId: vm.project.collector.id, // The collector who owns the project
            operatorId: Session.collector.id // The operator/artist who's logged in and has cancelled the apointment
          },
          messageVariables: {
            subject: Session.collector.first_name + ' ' +
            Session.collector.last_name +
            ` cancelled this appointment`
          }
        };
        Notification.send(cancelNotification);
      }
    });
  };

  vm.cancel = function() {
    $uibModalInstance.dismiss();
  };
}

angular
  .module('inkfinder')
  .controller('CancelAppointmentController', CancelAppointmentController);



// WEBPACK FOOTER //
// ./components/appointments/appointment/cancel/cancel.controller.js